/**
 * @desc 财务画像-基础信息
 */
import style from './common/common.scss';
import React, { PureComponent } from 'react';
import cns from 'classnames';
import { Tabs } from 'antd';
import { changeAnchor } from '../common/commons';
import BusinessInformation from './businessInformation/BusinessInformation'; // 工商信息
import EquityInformation from './equityInformation/EquityInformation'; // 股权信息
import Financial from './financial/Financial'; // 财务总览
import PersonnelMessage from './personnelMessage/PersonnelMessage'; // 人员信息
import ResearchAndEquity from './researchAndEquity/ResearchAndEquity'; // 研发及产权信息
const TabPane = Tabs.TabPane;

export default class BaseInfo extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            option: [
                {
                    val: 'busine', title: [
                        { name: '工商登记', id: 'business-regist' },
                        { name: '工商变更', id: 'business-change' }]
                },
                {
                    val: 'equity', title: [
                        { name: '子公司的构成', id: 'subsidiaries-constitute' },
                        { name: '前十大股东持股信息', id: 'top-ten-Shareholder' },
                        { name: '实际控制人及变更情况', id: 'actual-controller' },
                        // { name: '股东质押情况', id: 'pledge-shareholder' },
                        { name: '股东减持情况', id: 'reduce-shareholder' },
                        { name: '公司近年分红情况', id: 'company-dividend' }]
                },  
                {
                    val: 'financial', title: [
                        { name: '公司行业信息', id: 'company-industry' },
                        { name: '公司财务信息', id: 'company-financial' },
                        { name: '主营业务变动', id: 'business-change' },
                        { name: '主要财务指标趋势', id: 'financial-index' },
                        { name: '关键财务指标趋势对比', id: 'index-contrast' },
                        { name: '重要指标变动说明', id: 'index-change-explain' },
                        { name: '资产负债构成', id: 'asset-liabilities' },
                        { name: '季度营业情况', id: 'quarter-business' },
                        { name: '收入地区结构', id: 'income-region' },
                        { name: '销售产品结构', id: 'sales-product' },
                        { name: '报表项异常提示', id: 'normal-report-prompt' }]
                },
                {
                    val: 'personnel', title: [
                        { name: '高管学历情况', id: 'compensation-edu' },
                        { name: '员工构成', id: 'person-contrast' },
                        { name: '人才招聘', id: 'recruitment' }]
                },
                {
                    val: 'research', title: [
                        { name: '研发投入', id: 'research-put-into' },
                        { name: '研发结果', id: 'research-result' },
                        { name: '商标', id: 'trademark' },
                        { name: '软件著作', id: 'software' },
                        { name: '作品著作', id: 'production' }]
                }
            ]
        };
    }

    componentDidMount() {
        this.tabsCallback();
    }

    tabsCallback = (val) => {
        const { option } = this.state;
        let value = val ? val : 'busine', name = option.find((v) => v.val === value);
        changeAnchor(name.title);
    };

    render() {
        return (
            <div>
                <div className={style.bestInfo}>
                    <Tabs defaultActiveKey="busine" animated={false} className={cns('line-tabs margin')} onChange={(val) => this.tabsCallback(val)}>
                        <TabPane tab="工商信息" key="busine">
                            <BusinessInformation />
                        </TabPane>
                        <TabPane tab="股权信息" key="equity">
                            <EquityInformation />
                        </TabPane>
                        <TabPane tab="财务总览" key="financial">
                            <Financial />
                        </TabPane>
                        <TabPane tab="人员信息" key="personnel">
                            <PersonnelMessage />
                        </TabPane>
                        <TabPane tab="研发及产权信息" key="research">
                            <ResearchAndEquity />
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/BaseInfo.jsx